import { atom } from 'recoil'

export const shrimpTopupDateTableFilterState = atom<Date | undefined>({
  key: 'shrimpTopupDateTableFilterState',
  default: undefined,
})

export const selectedShrimpTopupState = atom<number | undefined>({
  key: 'selectedShrimpTopupState',
  default: undefined,
})
